import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

const useFavoritesStore = create(
  persist(
    (set, get) => ({
      favorites: [],

      toggle: async (service) => {
        const exists = get().favorites.some(s => s.id === service.id);
        // Optimistic update for instant UI feedback
        set(s => ({
          favorites: exists
            ? s.favorites.filter(f => f.id !== service.id)
            : [service, ...s.favorites]
        }));
        try {
          await api.post(`/favorites/${service.id}`);
        } catch {
          // Revert on failure
          set(s => ({
            favorites: exists
              ? [service, ...s.favorites]
              : s.favorites.filter(f => f.id !== service.id)
          }));
        }
      },

      isFavorite: (id) => get().favorites.some(s => s.id === id),

      syncFromServer: async () => {
        try {
          const { data } = await api.get('/favorites');
          set({ favorites: data });
        } catch {}
      }
    }),
    { name: 'findr-favorites' }
  )
);

export default useFavoritesStore;
